@if (vm$ | async; as vm) {
  @if (form$ | async; as form) {
    <form
      class="reactive-forms"
      [formGroup]="form"
      (ngSubmit)="vm.onSubmit(form)"
    >
      <dgx-modal
        [useDefaultForm]="false"
        [canCancel]="true"
        [submitButtonText]="vm.i18n.EventFormCtrl_SaveEvent"
        [isSubmitPending]="vm.shouldSpinSubmitButton$ | async"
        [modalHeaderTitle]="vm.modalHeader"
        bodyClasses="guts-p-h-2 guts-p-v-2"
      >
        <!-- Modal Body -->
        <ng-container class="modal-body">
          <!-- Created By -->
          @if (vm.inputContext.isEditing) {
            <div class="reactive-forms__control">
              <span class="par par--small">{{ vm.i18n.Core_CreatedBy }}</span>
            </div>
          }

          <!-- URL input-->
          <div class="reactive-forms__control">
            <dgx-reactive-forms-label for="eventUrl">
              {{ vm.i18n.EventFormCtrl_EventWebsite }}
            </dgx-reactive-forms-label>
            <input
              #eventUrl
              autocomplete="off"
              type="url"
              id="eventUrl"
              formControlName="eventUrl"
              placeholder="http://"
              aria-describedby="event-url-errors event-url-duplicates"
              data-dgat="event-catalog-038"
              (blur)="vm.fetchUrlDuplicates(eventUrl.value, vm.organizationId)"
            />
            @if (vm.duplicateCount && form.get('eventUrl').value) {
              <dgx-check-duplicate-inputs
                id="event-url-duplicates"
                [duplicateCount]="vm.duplicateCount"
                (viewDuplicates)="vm.viewDuplicates()"
              />
            }
            @if (vm.showError(form, 'eventUrl', 'touched')) {
              <dgx-validate-field
                id="event-url-errors"
                class="block"
                [message]="vm.i18n.EventFormCtrl_ValidUrl"
              />
            }
          </div>

          <!-- Title -->
          <div class="reactive-forms__control">
            <dgx-reactive-forms-label for="title" [isRequired]="true">
              {{ vm.i18n.Core_Title }}
            </dgx-reactive-forms-label>
            <input
              type="text"
              id="title"
              formControlName="title"
              [dgxAutofocus]="true"
              [placeholder]="vm.i18n.dgFlexRow_EditSectionTitlePlaceholder"
              [attr.aria-describedby]="
                vm.i18n.dgFlexRow_EditSectionTitlePlaceholder
              "
              data-dgat="event-catalog-6c9"
            />
            @if (vm.showError(form, 'title', 'touched')) {
              <dgx-validate-field
                class="block"
                [message]="vm.i18n.MediaFormCtrl_TitleRequired"
              />
            }
          </div>

          <!-- Description  -->
          <div class="reactive-forms__control">
            <dgx-reactive-forms-label for="description">
              {{ vm.i18n.Core_Description }}
            </dgx-reactive-forms-label>
            <textarea
              formControlName="summary"
              [attr.maxlength]="3000"
              [attr.aria-label]="
                vm.i18n.dgOrgInternalContentForm_EventDescriptionPlaceholder
              "
              id="description"
              [placeholder]="
                vm.i18n.dgOrgInternalContentForm_EventDescriptionPlaceholder
              "
              data-dgat="event-catalog-1f4"
            ></textarea>
          </div>

          <!-- Duration -->
          <div class="reactive-forms__control">
            <dgx-duration
              [formModel]="{
                durationHours: vm.durationHours,
                durationMinutes: vm.durationMinutes,
              }"
            />
          </div>

          <!-- Session Details -->
          <div class="reactive-forms__control">
            <dgx-session-details
              inputType="Event"
              [session]="vm.sessions?.[0]"
              [isSessionDetailsToggledOn]="vm.isSessionDetailsToggledOn"
              (onAddressChange)="vm.onAddressChange($event)"
              (onToggleOfSessionDetails)="vm.toggleSessionDetails($event)"
              (updateDurationBasedOnSessionTime)="
                vm.updateDuration($event, form)
              "
            />
          </div>

          <!-- Content Owner -->
          <div class="reactive-forms__control">
            <dgx-reactive-forms-label
              for="owner"
              icon="info"
              [isRequired]="true"
              [iconTooltip]="
                vm.i18n.dgOrgInternalContentForm_ContentOwnerTooltip
              "
              [iconA11yText]="vm.i18n.Core_MoreInfo"
            >
              {{ vm.i18n.dgOrgInternalContentForm_ContentOwner }}
            </dgx-reactive-forms-label>
            <dgx-user-search
              id="owner"
              [useSearchField]="false"
              [recipients]="!!vm.owner ? [vm.owner] : []"
              [search]="vm.loadGroupsUsersRecommendees"
              [ariaLabel]="vm.i18n.dgOrgInternalContentForm_ContentOwner"
              [allowRemoval]="true"
              (removeRecipient)="vm.onContentOwnerChange(undefined, form)"
              (selectRecipient)="vm.onContentOwnerChange($event, form)"
              (handleBlur)="vm.onContentOwnerBlur($event, form)"
              [placeholder]="
                vm.i18n.dgOrgInternalContentForm_ContentOwnerPlaceholder
              "
            />
            @if (vm.showError(form, 'owner', 'touched')) {
              <dgx-validate-field
                class="block"
                [message]="vm.getContentOwnerError(form)"
              />
            }
          </div>

          <!-- Image-->
          <div class="reactive-forms__control">
            <dgx-upload-section
              [imageUrl]="vm.imageUrl"
              [uploadAdapter]="vm.imageUploadAdapter"
              (imageParsedEvent)="vm.imageUpload.onParse($event)"
              (uploadSuccessEvent)="vm.imageUpload.onUpload(form, $event)"
              (deleteEvent)="vm.imageUpload.onDelete(form)"
              [useCropper]="true"
              [aspectRatio]="16 / 9"
              [secondaryAspectRatio]="16 / 5"
              [useBrowserReplace]="true"
            />
          </div>

          <!-- Skills-->
          <div class="reactive-forms__control">
            <dgx-tags-edit
              [hideHint]="true"
              [customTagToolTip]="
                vm.i18n.dgOrgInternalContent_SkillsTooltipText
              "
              [customTitle]="vm.i18n.Core_Skills"
              [topTags]="vm.mediumConfidenceInferredSkills"
              [hideTopTags]="!vm.mediumConfidenceInferredSkills?.length"
              [hideTooltip]="false"
              [tooltipIcon]="'info'"
              [placeholder]="
                vm.highConfidenceInferredSkills
                  ? vm.i18n.dgOrgInternalContent_SkillsPlaceholderText
                  : ''
              "
              [allowExistingOnly]="false"
              [tags]="vm.tags"
              [showFullWidthLabel]="true"
              [useNewTagsDesign]="true"
              (tagsChange)="vm.onFormControlUpdate(form, 'skills', $event)"
            />
            @if (vm.showError(form, 'skills', 'touched')) {
              <dgx-validate-field
                class="block"
                [message]="vm.i18n.dgOrgInternalContent_SkillsMaxError"
              />
            }
          </div>

          <!-- Advanced -->
          <div class="reactive-forms__control">
            <dgx-advanced-settings
              [formModel]="{
                visibility: vm.orgContentMetadata,
                publishedDate: vm.publishDate,
                internalItemId: vm.externalId,
                language: vm.language,
                isFileManaged: vm.fileManaged,
              }"
            />
          </div>
        </ng-container>
      </dgx-modal>
    </form>
  } @else {
    <!-- Loading spinner -->
    <dgx-modal
      [useDefaultForm]="false"
      [isLoading]="true"
      [modalHeaderTitle]="vm.modalHeader"
      bodyClasses="guts-p-h-2 guts-p-v-2"
    />
  }
}
